export const harvestYieldsData = {
  data: {
    field: {
      id: '0012d5c2-4a2d-4b97-b477-caebba3beb9d',
      seasons: [
        {
          seasonTag: '2016:corn-silage:US:2:SPR',
          harvest: {
            yield: {
              wetMass: {
                unit: 'kg',
                value: 47327.89229733748,
              },
              dryMass: {
                unit: 'kg',
                value: 4949.193538222375,
              },
              moisture: {
                unit: 'percent',
                value: 15.066010478306868,
              },
              totalYield: {
                unit: 'kg/ha',
                value: 4949.193538222375,
              },
              averageYield: {
                unit: 'kg/ha',
                value: 4543.569729726462,
              },
              area: {
                unit: 'ha',
                value: 10.16909344485,
              },
              averageDryYield: {
                unit: 'kg/ha',
                value: 4241.9922327329
              },
              standardisedAverageYield: {
                unit: 'kg/ha',
                value: 4241.9922327329
              }
            },
          },
          crop: {
            nominalWeight: {
              unit: 'lb/bu',
              value: 0,
            },
          },
        },
        {
          seasonTag: '2014:wheat-spring:US:2:SPR',
          harvest: {
            yield: {
              wetMass: {
                unit: 'kg',
                value: 677478.8907200892,
              },
              dryMass: {
                unit: 'bu',
                value: 4949.193538222375,
              },
              moisture: {
                unit: 'percent',
                value: 19.941280136581856,
              },
              totalYield: {
                unit: 'bu',
                value: 4949.193538222375,
              },
              averageYield: {
                unit: 'kg/ha',
                value: 16685.82991687367,
              },
              area: {
                unit: 'ha',
                value: 38.438148502748,
              },
              averageDryYield: undefined,
              standardisedAverageYield: undefined
            },
          },
          crop: {
            nominalWeight: {
              unit: 'lb/bu',
              value: 56,
            },
          },
        },
        {
          seasonTag: '2023:corn-silage:US:2:SPR',
          harvest: {
            yield: {
              wetMass: {
                unit: 'short-ton',
                value: 3383998.73,
              },
              dryMass: {
                unit: 'short-ton',
                value: 60428.54,
              },
              moisture: {
                unit: 'percent',
                value: 5.9999,
              },
              totalYield: {
                unit: 'short-ton',
                value: 60428.548,
              },
              averageYield: {
                unit: 'short-ton/ac',
                value: 1888839.22,
              },
              area: {
                unit: 'ac',
                value: 0.3199,
              },
              averageDryYield: {
                unit: 'short-ton/ac',
                value: 1574027.44
              },
              standardisedAverageYield: {
                unit: 'short-ton/ac',
                value: 1574027.44
              }
            },
          },
          crop: {
            nominalWeight: {
              unit: 'lb/bu',
              value: 0,
            },
          },
        },
        {
          seasonTag: '2023:sugarcane:US:2:SPR',
          harvest: {
            yield: {
              wetMass: {
                unit: 'lb',
                value: 200010,
              },
              dryMass: {
                unit: 'lb',
                value: 200010,
              },
              moisture: {
                unit: 'percent',
                value: 8.9999,
              },
              totalYield: {
                unit: 'lb',
                value: 200010,
              },
              averageYield: {
                unit: 'lb/ac',
                value: 1277.33,
              },
              area: {
                unit: 'ac',
                value: 156.58,
              },
              averageDryYield: undefined,
              standardisedAverageYield: undefined
            },
          },
          crop: {
            nominalWeight: {
              unit: 'lb/bu',
              value: 11.45,
            },
          },
        }
      ],
    },
  },
  extensions: {
    logging: {
      legacy: {
        totalRequests: 0,
        completedRequests: 0,
        failedRequests: 0,
      },
      dfp: {
        totalRequests: 0,
        completedRequests: 0,
        reusedRequestsDelta: 0,
        failedRequests: 0,
      },
      totalRequests: 0,
      totalReusedRequestDelta: 0,
      totalCompletedRequests: 0,
      totalFailedRequests: 0,
    },
  },
};